export default __webpack_public_path__ + "static/media/ptWebApp.6cae016e.png";